import { render, staticRenderFns } from "./CostDocumentsIcon.vue?vue&type=template&id=9630a3e0"
import script from "./CostDocumentsIcon.vue?vue&type=script&lang=ts"
export * from "./CostDocumentsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports